import Image from "next/image";
import type { ReactNode } from "react";

type Props = {
  iconSrc: string;
  iconAlt: string;
  children: ReactNode;
};

/**
 * 予約ページの注意書きの見出し部分を共通化したコンポーネント
 */
export function DescriptionHeader({ iconSrc, iconAlt, children }: Props) {
  return (
    <div className="flex">
      <Image src={iconSrc} alt={iconAlt} width={54} height={54} />
      <div className="ff-palt my-[10px] ml-[14px] flex items-center text-sm tracking-[0.07rem] md:text-base">
        {children}
      </div>
    </div>
  );
}
